import React, { useState, useEffect } from "react";
import axios from "axios";
import { TextField, Button, Checkbox, FormControlLabel, Select, MenuItem, InputLabel, FormControl, Grid, Typography, Paper, Container, Box, Card, CardContent } from "@mui/material";

import PWAHeader from "../common/PWAHeader";
import PrimaryButton from "../common/PrimaryButton";
import { add_address, fetch_addresses } from "../apiservices/ApiService";
const AddressList = ({ onAddressSelect, defaultShowAddAddress }) => {
    console.log("onAddressSelect", onAddressSelect, "defaultShowAddAddress", defaultShowAddAddress);
    const [addresses, setAddresses] = useState([]);
    const [showAddAddress, setShowAddAddress] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const fetchAddresses = async () => {
        try {
            const response = await fetch_addresses({});

            const addresses = response?.data?.addresses || [];
            setAddresses(addresses);
        } catch (err) {
            setError("Failed to fetch addresses: " + err.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        setLoading(true);
       

        fetchAddresses();
    }, []);

    // Handle adding new address
    const handleAddAddress = () => {
       
        setShowAddAddress(false);
        fetchAddresses();
    };

    // Handle the loading and error states
    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    return (
        <Box sx={{ maxWidth: "42rem", mx: "auto", display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: 'rgba(255, 152, 0, 0.11)' }}>
            {showAddAddress ? (
                <AddAddressForm onSave={handleAddAddress} onCancel={() => setShowAddAddress(false)} />
            ) : (
                <Box width="100%" >
                    <PWAHeader title="Address" onClick={() => onAddressSelect(null)} />

                    <Box sx={{ px: 2, py: 3 }}>


                        <PrimaryButton onClick={() => setShowAddAddress(true)} label="+ Add a New Address" />

                        <Typography variant="h6" color="#771615" gutterBottom>
                            Select a Delivery Address
                        </Typography>

                        <Grid container spacing={2}>
                            {addresses.map((address, index) => (
                                <Grid item xs={12} key={address.addressId}>
                                    <Card
                                        sx={{
                                            border: "1px solid #681517",
                                            boxShadow: "0 0px 4px 0px #681517",
                                            borderRadius: 2,
                                            cursor: "pointer",
                                            "&:hover": { boxShadow: "0 0px 8px 0px #681517" },
                                            background: 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.5) 100%)',
                                            background: index % 2 === 0 ? 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.5) 100%)' : 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.5) 100%)',

                                        }}
                                        onClick={() => onAddressSelect(address)}
                                    >
                                        <CardContent sx={{ color: "#771615" }}>
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {address.name}
                                            </Typography>
                                            <Typography variant="body2">{address.address}</Typography>
                                            <Typography variant="body2">
                                                {address.city}, {address.state} - {address.pinCode}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {address.mobile}
                                            </Typography>
                                            {address.isDefault === "Y" && (
                                                <Typography variant="body2" color="#681517" fontWeight="bold">
                                                    Default Address
                                                </Typography>
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

const AddAddressForm = ({ onSave, onCancel }) => {
    const queryParams = new URLSearchParams(window.location.search);

    var appType = queryParams.get("appType");


    const [formData, setFormData] = useState({
        addressId: Math.random().toString(36).substr(2, 9),
        name: "",
        email: "",
        mobile: "",
        address: "",
        landmark: "",
        city: "",
        state: "",
        pinCode: "",
        isDefault: "N",
    });

    const [errors, setErrors] = useState({});
    const [cities, setCities] = useState([]);  // List of cities based on selected state

    // Hardcoded list of states and cities
    const statesAndCities = {
        "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kakinada"],
        "Arunachal Pradesh": ["Itanagar", "Tawang", "Ziro", "Pasighat", "Tezu"],
        "Assam": ["Guwahati", "Dibrugarh", "Jorhat", "Nagaon", "Silchar"],
        "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Munger"],
        "Chhattisgarh": ["Raipur", "Bilaspur", "Korba", "Durg", "Raigarh"],
        "Goa": ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
        "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
        "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Hisar"],
        "Himachal Pradesh": ["Shimla", "Manali", "Kullu", "Solan", "Mandi"],
        "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Deoghar", "Hazaribagh"],
        "Karnataka": ["Bengaluru", "Mysuru", "Hubballi", "Mangalore", "Belagavi"],
        "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Kollam", "Thrissur"],
        "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain"],
        "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane"],
        "Manipur": ["Imphal", "Churachandpur", "Bishnupur", "Thoubal", "Senapati"],
        "Meghalaya": ["Shillong", "Tura", "Jowai", "Nongpoh", "Williamnagar"],
        "Mizoram": ["Aizawl", "Lunglei", "Champhai", "Kolasib", "Serchhip"],
        "Nagaland": ["Kohima", "Dimapur", "Mokokchung", "Wokha", "Mon"],
        "Odisha": ["Bhubaneswar", "Cuttack", "Berhampur", "Rourkela", "Sambalpur"],
        "Punjab": ["Chandigarh", "Amritsar", "Ludhiana", "Jalandhar", "Patiala"],
        "Rajasthan": ["Jaipur", "Udaipur", "Jodhpur", "Kota", "Ajmer"],
        "Sikkim": ["Gangtok", "Jorethang", "Mangan", "Namchi", "Rangpo"],
        "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Trichy", "Salem"],
        "Telangana": ["Hyderabad", "Warangal", "Khammam", "Karimnagar", "Nizamabad"],
        "Tripura": ["Agartala", "Udaipur", "Dharmanagar", "Kailashahar", "Sonamura"],
        "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Allahabad"],
        "Uttarakhand": ["Dehradun", "Haridwar", "Nainital", "Rishikesh", "Roorkee"],
        "West Bengal": ["Kolkata", "Siliguri", "Howrah", "Durgapur", "Asansol"],
        "Andaman and Nicobar Islands": ["Port Blair", "Diglipur", "Car Nicobar", "Mayabunder", "Havelock Island"],
        "Chandigarh": ["Chandigarh"],
        "Dadra and Nagar Haveli and Daman and Diu": ["Daman", "Diu", "Silvassa"],
        "Lakshadweep": ["Kavaratti", "Agatti", "Andrott", "Minicoy", "Chetlat"],
        "Delhi": ["New Delhi", "North Delhi", "South Delhi", "East Delhi", "West Delhi"],
        "Puducherry": ["Puducherry", "Auroville", "Karaikal", "Mahe", "Yanam"]
    };


    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setFormData({ ...formData, state: selectedState, city: "" }); // Reset city if state changes
        if (selectedState) {
            setCities(statesAndCities[selectedState] || []); // Set cities based on selected state
        } else {
            setCities([]);  // Clear cities if no state is selected
        }
    };
    // const handleStateChange = (e) => {
    //     const selectedState = e.target.value;
    //     setFormData(prev => ({ ...prev, state: selectedState, city: "" }));
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.name) errors.name = "Name is required";
        if (!formData.email) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Email is invalid";
        }
        if (!formData.mobile) {
            errors.mobile = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobile)) {
            errors.mobile = "Mobile number must be 10 digits";
        }
        if (!formData.address) errors.address = "Address is required";
        if (!formData.city) errors.city = "City is required";
        if (!formData.state) errors.state = "State is required";
        if (!formData.pinCode) {
            errors.pinCode = "Pin Code is required";
        } else if (!/^\d{6}$/.test(formData.pinCode)) {
            errors.pinCode = "Pin Code must be 6 digits";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) {
            return;
        }

       



        try {
            const { email, name, city, address, pinCode, mobile, landmark, state, isDefault } = formData;
        
            const response = await add_address({
                email,
                name,
                city,
                address,
                pinCode,
                mobile,
                landmark,
                state,
                isDefault
            });
        
            console.log("add_address :", response);
        
            if (response.code === 200 && response.data) {
                console.log("add_address :", response.data);


                onSave();
                
            } else {
                console.error("Unexpected response structure:", response);
            }
        } catch (err) {
            console.error("Error adding address:", err.message || err);
        }
    };

    return (
        <>

            <PWAHeader title={"Add a New Address"} onClick={onCancel} />

            <Container maxWidth="sm" sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
                <Paper elevation={3} sx={{ padding: 2, marginTop: 1, background: 'linear-gradient(to right, #fff 0%, rgba(255, 152, 0, 0.5) 100%)' }}>
                    {[
                        { label: "Name", name: "name", required: true },
                        { label: "Email", name: "email", required: true },
                        { label: "Mobile", name: "mobile", required: true },
                        { label: "Address", name: "address", required: true },
                        { label: "Landmark", name: "landmark" },
                        { label: "Pincode", name: "pinCode", required: true },
                    ].map(({ label, name, required }) => (
                        <TextField
                            key={name}
                            label={label}
                            name={name}
                            value={formData[name]}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            required={required}
                            error={!!errors[name]}
                            helperText={errors[name] || ""}
                            sx={{
                                background: 'linear-gradient(to left, #fff 0%, rgba(255, 152, 0, 0.2) 100%)',
                                borderRadius: '10px',
                                border: '1px solid #681517',
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#681517',
                                    },
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#681517',
                                },
                            }}
                        />
                    ))}

                    {/* State Selection */}
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Select State</InputLabel>
                        <Select
                            name="state"
                            value={formData.state}
                            // onChange={handleChange}
                            onChange={handleStateChange}
                            sx={{
                                background: 'linear-gradient(to left, #fff 0%, rgba(255, 152, 0, 0.2) 100%)',
                                borderRadius: '10px',
                                border: '1px solid #681517',
                                '& .MuiOutlinedSelect-root': {
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#681517',
                                    },
                                },
                                '& .MuiSelectLabel-root.Mui-focused': {
                                    color: '#681517',
                                },
                            }}
                        >
                            <MenuItem sx={{ color: '#681517', backgroundColor: '#FFE9E9', "&:hover": { color: '#681517', backgroundColor: '#FF7B7C' } }} value="">Select State</MenuItem>
                            {Object.keys(statesAndCities).map((state) => (
                                <MenuItem sx={{ color: '#681517', backgroundColor: '#FFE9E9', "&:hover": { color: '#681517', backgroundColor: '#FF7B7C' } }} key={state} value={state}>{state}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* City Selection */}
                    <FormControl fullWidth margin="normal" disabled={!formData.state}>
                        <InputLabel>Select City</InputLabel>
                        <Select
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            sx={{
                                background: 'linear-gradient(to left, #fff 0%, rgba(255, 152, 0, 0.2) 100%)',
                                borderRadius: '10px',
                                border: '1px solid #681517',

                            }}
                        >
                            <MenuItem sx={{ color: '#681517', backgroundColor: '#FFE9E9', "&:hover": { color: '#681517', backgroundColor: '#FF7B7C' } }} value="">Select City</MenuItem>
                            {cities.length > 0 ? (
                                cities.map((city) => (
                                    <MenuItem sx={{ color: '#681517', backgroundColor: '#FFE9E9', "&:hover": { color: '#681517', backgroundColor: '#FF7B7C' } }} key={city} value={city}>{city}</MenuItem>
                                ))
                            ) : (
                                <MenuItem sx={{ color: '#681517', backgroundColor: '#FFE9E9', "&:hover": { color: '#681517', backgroundColor: '#FF7B7C' } }} disabled>No cities available</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControlLabel
                        control={<Checkbox sx={{ color: '#681517', '&.Mui-checked': { color: '#681517' } }} checked={formData.isDefault === "Y"} onChange={(e) => setFormData({ ...formData, isDefault: e.target.checked ? "Y" : "N" })} />}
                        label="Set as default for delivery"
                        sx={{ color: '#681517' }}
                    />

                    <Box sx={{ marginTop: 1, display: "flex", justifyContent: "space-between" }}>

                        {/* Log Button */}
                        <PrimaryButton onClick={handleSave} label="Save" />

                        <PrimaryButton onClick={onCancel} label="Cancel" />

                    </Box>
                </Paper>
            </Container>
        </>
    );
};

export default AddressList;
